import { FC } from 'react';
import classNames from 'classnames';
import { SignatureUser } from '../../generated/graphql';
import {
  getColorForSignatureUserType,
  SignatureUserTypeLabel,
} from '../lib/multiSignature';

interface SignatureChipProps {
  signerType: SignatureUser;
  className?: string;
}

const SignatureChip: FC<SignatureChipProps> = ({ signerType, className }) => {
  const colorScheme = getColorForSignatureUserType(signerType);

  return (
    <div
      className={classNames(
        'text-neutral-700 inline-flex items-center rounded-full px-1.5 py-0.5 text-small-label',
        colorScheme.backgroundColor,
        className,
      )}
    >
      <span>{SignatureUserTypeLabel[signerType]}</span>
    </div>
  );
};

export default SignatureChip;
